module.exports = __webpack_public_path__ + "media/photo/development_overlay-b5f11d29.jpg";